
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import { getTableName } from '@/worker/db/sqlHelpers';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import SlPhModuleOnlyToggle from '@/components/SlPhModuleOnlyToggle.vue';
import settingx from '@/store/modules/settingx';

@Component({
	components: {
		AmountDisplayerFilterable,
		SlPhModuleOnlyToggle,
	},
})
export default class PurchaseTotalCreditNoteNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['purchases'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateRange'];

	public amount: number = 0;

	public get slPhModuleOnly() {
		return settingx.now.slPhModuleOnly;
	}

	public get expensiveHook() {
		const { selectedDateRange, slPhModuleOnly } = this;
		return JSON.stringify([selectedDateRange, slPhModuleOnly]);
	}

	public async expensiveCalc() {
		const jobId = this.currentJobId;
		this.generateLoadingText(0.2, 0.3);

		const queryHead = await this._ensureTablesLoaded(['purchaseReturn', 'supplierTrades'] as any[]);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.3, 0.9);

		const dateFilter = `TRY_CAST("DOCDATE" AS BIGINT) >= ${this.selectedDateRange[0]} AND TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedDateRange[1]}`;

		let result: any[];

		if (this.slPhModuleOnly) {
			// PH Mode - use purchaseReturn
			result = await queryHead.rawQuery(
				`SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total FROM ${getTableName('purchaseReturn')} WHERE ${dateFilter}`,
			);
		} else {
			// AP Mode - use supplierTrades with SC docType
			result = await queryHead.rawQuery(
				`SELECT SUM(TRY_CAST("LOCALAMOUNT" AS DOUBLE)) as total FROM ${getTableName('supplierTrades')} WHERE ${dateFilter} AND "DOCTYPE" = 'SC'`,
			);
		}
		this.checkInterrupted(jobId);

		this.amount = (result[0] && Number(result[0].total)) || 0;

		this.generateLoadingText(1);
		this.saveHistory('amount');
	}
}
